export const prepareExportClientsCSV = (data?: string) => {
  if (!data) {
    return data;
  }

  return data.replace(/null/g, '-');
};
